export default __webpack_public_path__ + "static/media/114.0bea2f9d.png";